export const data: {
	title: string;
	description: string;
}[] = [
	{
		title: 'Open company, no bullshit',
		description: `Openness is root level for us. Information is open internally by default and sharing is a first principle. And we understand that speaking your mind requires equal parts brains (what to say), thoughtfulness (when to say it), and caring (how it's said).`,
	},
	{
		title: 'Build with heart and balance',
		description: `Measure twice, cut once. Whether you're building a birdhouse or a business, this is good advice. Passion and urgency infuse everything we do, alongside the wisdom to consider options fully and with care. Then we make the cut, and we get to work.`,
	},
	{
		title: `Don't #@!% the customer`,
		description: `Customers are our lifeblood. Without happy customers, we're doomed. So considering the customer perspective - collectively, not just a handful - comes first.`,
	},
	{
		title: 'Play, as a team',
		description: `We spend a huge amount of our time at work. So the more that time doesn't feel like “work,” the better. We can be serious, without taking ourselves too seriously. We strive to put what's right for the team first - whether in a meeting room or on a football pitch.`,
	},
	{
		title: 'Be the change you seek',
		description:
			'All Atlassians should have the courage and resourcefulness to spark change - to make better our apps, our people, our place. Continuous improvement is a shared responsibility. Action is an independent one.',
	},
];
